<ng-container *ngIf="otherLogins.length">
  <div class="container">
    <div class="item" *ngFor="let item of otherLogins" (click)="loginVer(item.name)">
      <cs-icon-button iconType="image" [icon]="item.pic" [hasFrame]="true" frameShape="square"></cs-icon-button>
      <ng-container *ngIf="item.src && item.name === 'Telegram'">
        <iframe [src]="item.src | safe" (load)="buildClick(item)"></iframe>
      </ng-container>
    </div>
  </div>
</ng-container>
